import Vue from 'vue'
import VueRouter, { RouteConfig, Route, NavigationGuardNext } from 'vue-router'

import { UserRole } from '@/types/user'

import store from '@/store'

import Top from '@/components/pages/Top.vue'
import Login from '@/components/pages/Login.vue'
import InputEmail from '@/components/pages/InputEmail.vue'
import PasswordSetting from '@/components/pages/PasswordSetting.vue'
import UncheckedReceipts from '@/components/pages/UncheckedReceipts.vue'
import LinkerCheckedReceipts from '@/components/pages/LinkerCheckedReceipts.vue'
import LeaderCheckedReceipts from '@/components/pages/LeaderCheckedReceipts.vue'
import UncheckedSystemNgReceipts from '@/components/pages/UncheckedSystemNgReceipts.vue'
import SystemNgReceipts from '@/components/pages/SystemNgReceipts.vue'
import SystemOkReceipts from '@/components/pages/SystemOkReceipts.vue'
import LinkerNgReceipts from '@/components/pages/LinkerNgReceipts.vue'
import LeaderNgReceipts from '@/components/pages/LeaderNgReceipts.vue'
import Ocr from '@/components/pages/Ocr.vue'
import QuestionnaireAnswer from '@/components/pages/QuestionnaireAnswer.vue'
import UserEdit from '@/components/pages/UserEdit.vue'
import NoticeEdit from '@/components/pages/NoticeEdit.vue'
import NewItems from '@/components/pages/NewItems.vue'
import NewMatchedItems from '@/components/pages/NewMatchedItems.vue'
import ReItems from '@/components/pages/ReItems.vue'
import ShopUncheckedReceipts from '@/components/pages/ShopUncheckedReceipts.vue'
import AdminRecommends from '@/components/pages/AdminRecommends.vue'
import AdminBrandSkus from '@/components/pages/AdminBrandSkus.vue'
import AdminMatcheds from '@/components/pages/AdminMatcheds.vue'
import ReMatcheds from '@/components/pages/ReMatcheds.vue'
import AdminLogs from '@/components/pages/AdminLogs.vue'
import QuestionnaireAdminLogs from '@/components/pages/QuestionnaireAdminLogs.vue'
import AdminContributers from '@/components/pages/AdminContributers.vue'
import Monitors from '@/components/pages/Monitors.vue'
import Users from '@/components/pages/Users.vue'
import Notices from '@/components/pages/Notices.vue'
import AutomaticQuestionnaire from '@/components/pages/AutomaticQuestionnaire.vue'
import AdminAutomaticQuestionnaireAnswer from '@/components/pages/AdminAutomaticQuestionnaireAnswer.vue'
import AdminManualQuestionnaireAnswer from '@/components/pages/AdminManualQuestionnaireAnswer.vue'
import LeaderAutomaticQuestionnaireAnswer from '@/components/pages/LeaderAutomaticQuestionnaireAnswer.vue'
import LeaderManualQuestionnaireAnswer from '@/components/pages/LeaderManualQuestionnaireAnswer.vue'
import UncheckedAutomaticQuestionnaireAnswer from '@/components/pages/UncheckedAutomaticQuestionnaireAnswer.vue'
import UncheckedManualQuestionnaireAnswer from '@/components/pages/UncheckedManualQuestionnaireAnswer.vue'
import QuestionnaireDetail from '@/components/pages/QuestionnaireDetail.vue'
import NewQuestionnaire from '@/components/pages/NewQuestionnaire.vue'
import CreateQuestionnairePage from '@/components/pages/CreateQuestionnairePage.vue'
import CreateQuestion from '@/components/pages/CreateQuestion.vue'
import EditQuestionnairePage from '@/components/pages/EditQuestionnairePage.vue'
import EditQuestion from '@/components/pages/EditQuestion.vue'
import ConditionList from '@/components/pages/ConditionList.vue'
import ConditionEdit from '@/components/pages/ConditionEdit.vue'
import QuestionnaireEdit from '@/components/pages/QuestionnaireEdit.vue'
import ManualQuestionnaire from '@/components/pages/ManualQuestionnaire.vue'
import SpecialOffer from '@/components/pages/SpecialOffer.vue'
import SpecialOfferEdit from '@/components/pages/SpecialOfferEdit.vue'
import UncheckedSpecialOfferReceipt from '@/components/pages/UncheckedSpecialOfferReceipt.vue'
import UncheckedNgSpecialOfferReceipt from '@/components/pages/UncheckedNgSpecialOfferReceipt.vue'
import UncheckedOkSpecialOfferReceipt from '@/components/pages/UncheckedOkSpecialOfferReceipt.vue'
import LeaderCheckedSpecialOfferReceipt from '@/components/pages/LeaderCheckedSpecialOfferReceipt.vue'
import LeaderNgSpecialOfferReceipt from '@/components/pages/LeaderNgSpecialOfferReceipt.vue'
import AdminSpecialOfferReceipt from '@/components/pages/AdminSpecialOfferReceipt.vue'
import CheckSpecialOfferReceipt from '@/components/pages/CheckSpecialOfferReceipt.vue'

export type NavLink = {
  title: string
  icon: string
  permission: 'all' | 'leader' | 'admin'
  links: {
    title: string
    to: string
    summaryKey?: string
    summaryKeyChild?: string
  }[]
  isOpenByDefault: boolean
}

export const passwordSettingUrl = process.env.VUE_APP_URL + 'password-setting'

export const navLinks: NavLink[] = [
  {
    title: 'リンカー作業',
    icon: 'mdi-account-circle',
    permission: 'all',
    links: [
      {
        title: '未チェック',
        to: '/unchecked-receipts',
        summaryKey: 'linker',
        summaryKeyChild: 'incompleted',
      },
    ],
    isOpenByDefault: true,
  },
  {
    title: 'チェッカー作業',
    icon: 'mdi-account-circle',
    permission: 'all',
    links: [
      {
        title: '手動アンケート',
        to: '/unchecked-manual-questionnaire-answer',
        summaryKey: 'linker',
        summaryKeyChild: 'incompleted',
      },
      {
        title: '自動アンケート',
        to: '/unchecked-automatic-questionnaire-answer',
        summaryKey: 'linker',
        summaryKeyChild: 'incompleted',
      },
      {
        title: 'Dely未チェック',
        to: '/unchecked-special-offer-receipts',
      },
    ],
    isOpenByDefault: true,
  },
  {
    title: 'リーダー作業 | 処理残',
    icon: 'mdi-check',
    permission: 'leader',
    links: [
      {
        title: 'システムNG',
        to: '/unchecked-system-ng-receipts',
        summaryKey: 'leaderForSystemNg',
        summaryKeyChild: 'incompleted',
      },
      {
        title: 'リンカーNG',
        to: '/linker-ng-receipts',
        summaryKey: 'leaderForLinkerNg',
        summaryKeyChild: 'incompleted',
      },
      {
        title: 'DelyNG',
        to: '/unchecked-ng-special-offer-receipts',
      },
      {
        title: 'DelyOK',
        to: '/unchecked-ok-special-offer-receipts',
      },
      {
        title: '自動紐付商品（マスタ）',
        to: '/new-items',
        // summaryKey: 'newItem',
      },
      {
        title: '自動紐付商品（学習）',
        to: '/new-matched-items',
        // summaryKey: 'newMatchedItem',
      },
      {
        title: '手動紐付商品',
        to: '/re-items',
        // summaryKey: 'reItem',
      },
    ],
    isOpenByDefault: true,
  },
  {
    title: 'リーダー作業 | 処理結果',
    icon: 'mdi-check',
    permission: 'leader',
    links: [
      {
        title: 'システムNG',
        to: '/system-ng-receipts',
      },
      {
        title: 'システムOK',
        to: '/system-ok-receipts',
      },
      {
        title: 'リンカーOK',
        to: '/linker-checked-receipts',
      },
      {
        title: 'リーダーOK',
        to: '/leader-checked-receipts',
      },
      {
        title: 'リーダーNG',
        to: '/leader-ng-receipts',
      },
      {
        title: 'DelyOK',
        to: '/leader-checked-special-offer-receipts',
      },
      {
        title: 'DelyNG',
        to: '/leader-ng-special-offer-receipts',
      },
    ],
    isOpenByDefault: false,
  },
  {
    title: 'リーダー作業 | マスター',
    icon: 'mdi-check',
    permission: 'leader',
    links: [
      {
        title: '紐付個別修正',
        to: '/re-matcheds',
      },
      {
        title: 'マッチ済検索',
        to: '/admin-matcheds',
      },
    ],
    isOpenByDefault: true,
  },
  {
    title: 'リーダー作業 | アンケート',
    icon: 'mdi-account-circle',
    permission: 'leader',
    links: [
      {
        title: '手動アンケート',
        to: '/ng-manual-questionnaire-answer',
      },
      {
        title: '自動アンケート',
        to: '/ng-automatic-questionnaire-answer',
      },
    ],
    isOpenByDefault: true,
  },
  {
    title: '管理者作業',
    icon: 'mdi-check',
    permission: 'admin',
    links: [
      {
        title: '店舗登録申請一覧',
        to: '/shop-unchecked-receipts',
        summaryKey: 'leaderForSystemNg',
        summaryKeyChild: 'shopApplying',
      },
      {
        title: '手動アンケート一覧',
        to: '/manual',
      },
      {
        title: '自動アンケート一覧',
        to: '/automatic',
      },
      {
        title: '手動アンケート回答一覧',
        to: '/manual-questionnaire-answer',
      },
      {
        title: '自動アンケート回答一覧',
        to: '/automatic-questionnaire-answer',
      },
      {
        title: 'Dely案件一覧',
        to: '/special-offers',
      },
      {
        title: 'Delyレシート一覧',
        to: '/special-offer-receipts',
      },
      {
        title: 'レコメンド検索',
        to: '/admin-recommends',
      },
      {
        title: '商品マスタ検索',
        to: '/admin-brand-skus',
      },
      {
        title: '作業ログ一覧',
        to: '/admin-logs',
      },
      {
        title: 'アンケート作業ログ一覧',
        to: '/questionnaire-admin-logs',
      },
      {
        title: '投稿者情報一覧',
        to: '/admin-contributers',
      },
      {
        title: 'モニター情報一覧',
        to: '/monitors',
      },
      {
        title: 'ユーザー情報一覧',
        to: '/users',
      },
      {
        title: 'お知らせ情報一覧',
        to: '/notices',
      },
    ],
    isOpenByDefault: true,
  },
]

Vue.use(VueRouter)

const checkPermission = async (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>,
) => {
  const user = await store.getters['user/user']
  switch (to.name) {
    case 'Top':
    case 'Login':
    case 'InputEmail':
    case 'PasswordSetting':
    case 'UncheckedReceipts':
    case 'UncheckedSpecialOfferReceipt':
      next()
      break
    case 'LinkerCheckedReceipts':
    case 'LeaderCheckedReceipts':
    case 'SystemNgReceipts':
    case 'SystemOkReceipts':
    case 'UncheckedSystemNgReceipts':
    case 'LinkerNgReceipts':
    case 'LeaderNgReceipts':
    case 'ReMatcheds':
    case 'AdminMatcheds':
    case 'LeaderAutomaticQuestionnaireAnswer':
    case 'LeaderManualQuestionnaireAnswer':
    case 'UncheckedNgSpecialOfferReceipt':
    case 'UncheckedOkSpecialOfferReceipt':
    case 'LeaderCheckedSpecialOfferReceipt':
    case 'LeaderNgSpecialOfferReceipt':
      if (user.role === UserRole.LEADER || user.role === UserRole.ADMIN) {
        next()
      } else {
        next({ path: '/' })
      }
      break
    case 'ShopUncheckedReceipts':
    case 'AdminRecommends':
    case 'AdminBrandSkus':
    case 'AdminLogs':
    case 'QuestionnaireAdminLogs':
    case 'AdminContributers':
    case 'Monitors':
    case 'Users':
    case 'UserEdit':
    case 'Notices':
    case 'NoticeEdit':
    case 'AutomaticQuestionnaire':
    case 'AutomaticQuestionnaireDetail':
    case 'AutomaticNewQuestionnaire':
    case 'AutomaticCreateQuestionnairePage':
    case 'AutomaticCreateQuestion':
    case 'AutomaticEditQuestionnairePage':
    case 'AutomaticEditQuestion':
    case 'AutomaticConditionList':
    case 'AutomaticConditionEdit':
    case 'AutomaticQuestionnaireEdit':
    case 'ManualQuestionnaire':
    case 'ManualQuestionnaireDetail':
    case 'ManualNewQuestionnaire':
    case 'ManualCreateQuestionnairePage':
    case 'ManualCreateQuestion':
    case 'ManualEditQuestionnairePage':
    case 'ManualEditQuestion':
    case 'ManualConditionList':
    case 'ManualConditionEdit':
    case 'ManualQuestionnaireEdit':
    case 'AdminAutomaticQuestionnaireAnswer':
    case 'AdminManualQuestionnaireAnswer':
    case 'SpecialOffer':
    case 'SpecialOfferEdit':
    case 'AdminSpecialOfferReceipt':
      if (user.role === UserRole.ADMIN) {
        next()
      } else {
        next({ path: '/' })
      }

      break
    default:
      next({ path: '/' })
  }
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Top',
    component: Top,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/input-email',
    name: 'ImputEmail',
    component: InputEmail,
  },
  {
    path: '/password-setting',
    name: 'PasswordSetting',
    component: PasswordSetting,
  },
  {
    path: '/unchecked-receipts',
    name: 'UncheckedReceipts',
    component: UncheckedReceipts,
  },
  {
    path: '/unchecked-manual-questionnaire-answer',
    name: 'UncheckedManualQuestionnaireAnswer',
    component: UncheckedManualQuestionnaireAnswer,
  },
  {
    path: '/unchecked-automatic-questionnaire-answer',
    name: 'UncheckedAutomaticQuestionnaireAnswer',
    component: UncheckedAutomaticQuestionnaireAnswer,
  },
  {
    path: '/automatic-questionnaire-answer',
    name: 'AdminAutomaticQuestionnaireAnswer',
    component: AdminAutomaticQuestionnaireAnswer,
  },
  {
    path: '/manual-questionnaire-answer',
    name: 'AdminManualQuestionnaireAnswer',
    component: AdminManualQuestionnaireAnswer,
  },
  {
    path: '/ng-automatic-questionnaire-answer',
    name: 'LeaderAutomaticQuestionnaireAnswer',
    component: LeaderAutomaticQuestionnaireAnswer,
  },
  {
    path: '/ng-manual-questionnaire-answer',
    name: 'LeaderManualQuestionnaireAnswer',
    component: LeaderManualQuestionnaireAnswer,
  },
  {
    path: '/linker-checked-receipts',
    name: 'LinkerCheckedReceipts',
    component: LinkerCheckedReceipts,
    beforeEnter: checkPermission,
  },
  {
    path: '/leader-checked-receipts',
    name: 'LeaderCheckedReceipts',
    component: LeaderCheckedReceipts,
    beforeEnter: checkPermission,
  },
  {
    path: '/unchecked-system-ng-receipts',
    name: 'UncheckedSystemNgReceipts',
    component: UncheckedSystemNgReceipts,
    beforeEnter: checkPermission,
  },
  {
    path: '/system-ng-receipts',
    name: 'SystemNgReceipts',
    component: SystemNgReceipts,
    beforeEnter: checkPermission,
  },
  {
    path: '/system-ok-receipts',
    name: 'SystemOkReceipts',
    component: SystemOkReceipts,
    beforeEnter: checkPermission,
  },
  {
    path: '/linker-ng-receipts',
    name: 'LinkerNgReceipts',
    component: LinkerNgReceipts,
    beforeEnter: checkPermission,
  },
  {
    path: '/leader-ng-receipts',
    name: 'LeaderNgReceipts',
    component: LeaderNgReceipts,
    beforeEnter: checkPermission,
  },
  {
    path: '/ocr',
    name: 'Ocr',
    component: Ocr,
  },
  {
    path: '/questionnaire-answer',
    name: 'QuestionnaireAnswer',
    component: QuestionnaireAnswer,
  },
  {
    path: '/new-items',
    name: 'NewItems',
    component: NewItems,
  },
  {
    path: '/new-matched-items',
    name: 'NewMatchedItems',
    component: NewMatchedItems,
  },
  {
    path: '/re-items',
    name: 'ReItems',
    component: ReItems,
  },
  {
    path: '/shop-unchecked-receipts',
    name: 'ShopUncheckedReceipts',
    component: ShopUncheckedReceipts,
    beforeEnter: checkPermission,
  },
  {
    path: '/admin-recommends',
    name: 'AdminRecommends',
    component: AdminRecommends,
    beforeEnter: checkPermission,
  },
  {
    path: '/admin-brand-skus',
    name: 'AdminBrandSkus',
    component: AdminBrandSkus,
    beforeEnter: checkPermission,
  },
  {
    path: '/admin-matcheds',
    name: 'AdminMatcheds',
    component: AdminMatcheds,
    beforeEnter: checkPermission,
  },
  {
    path: '/re-matcheds',
    name: 'ReMatcheds',
    component: ReMatcheds,
    beforeEnter: checkPermission,
  },
  {
    path: '/admin-logs',
    name: 'AdminLogs',
    component: AdminLogs,
    beforeEnter: checkPermission,
  },
  {
    path: '/questionnaire-admin-logs',
    name: 'QuestionnaireAdminLogs',
    component: QuestionnaireAdminLogs,
    beforeEnter: checkPermission,
  },
  {
    path: '/admin-contributers',
    name: 'AdminContributers',
    component: AdminContributers,
    beforeEnter: checkPermission,
  },
  {
    path: '/monitors',
    name: 'Monitors',
    component: Monitors,
    beforeEnter: checkPermission,
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    beforeEnter: checkPermission,
  },
  {
    path: '/user-edit',
    name: 'UserEdit',
    component: UserEdit,
    beforeEnter: checkPermission,
  },
  {
    path: '/notices',
    name: 'Notices',
    component: Notices,
    beforeEnter: checkPermission,
  },
  {
    path: '/notice-edit',
    name: 'NoticeEdit',
    component: NoticeEdit,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic',
    name: 'AutomaticQuestionnaire',
    component: AutomaticQuestionnaire,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic/:id/detail',
    name: 'AutomaticQuestionnaireDetail',
    component: QuestionnaireDetail,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic/:id/edit',
    name: 'AutomaticQuestionnaireEdit',
    component: QuestionnaireEdit,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic/new',
    name: 'AutomaticNewQuestionnaire',
    component: NewQuestionnaire,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic/:id/create-page',
    name: 'AutomaticCreateQuestionnairePage',
    component: CreateQuestionnairePage,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic/:id/page/:pageId/create-question',
    name: 'AutomaticCreateQuestion',
    component: CreateQuestion,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic/:id/page/:pageId/edit',
    name: 'AutomaticEditQuestionnairePage',
    component: EditQuestionnairePage,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic/:id/page/:pageId/question/:questionId/edit',
    name: 'AutomaticEditQuestion',
    component: EditQuestion,
    beforeEnter: checkPermission,
  },
  {
    path: '/automatic/:id/page/:pageId/question/:questionId/condition',
    name: 'AutomaticConditionList',
    component: ConditionList,
    beforeEnter: checkPermission,
  },
  {
    path:
      '/automatic/:id/page/:pageId/question/:questionId/condition/:conditionId',
    name: 'AutomaticConditionEdit',
    component: ConditionEdit,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual',
    name: 'ManualQuestionnaire',
    component: ManualQuestionnaire,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual/:id/detail',
    name: 'ManualQuestionnaireDetail',
    component: QuestionnaireDetail,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual/:id/edit',
    name: 'ManualQuestionnaireEdit',
    component: QuestionnaireEdit,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual/new',
    name: 'ManualNewQuestionnaire',
    component: NewQuestionnaire,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual/:id/create-page',
    name: 'ManualCreateQuestionnairePage',
    component: CreateQuestionnairePage,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual/:id/page/:pageId/create-question',
    name: 'ManualCreateQuestion',
    component: CreateQuestion,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual/:id/page/:pageId/edit',
    name: 'ManualEditQuestionnairePage',
    component: EditQuestionnairePage,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual/:id/page/:pageId/question/:questionId/edit',
    name: 'ManualEditQuestion',
    component: EditQuestion,
    beforeEnter: checkPermission,
  },
  {
    path: '/manual/:id/page/:pageId/question/:questionId/condition',
    name: 'ManualConditionList',
    component: ConditionList,
    beforeEnter: checkPermission,
  },
  {
    path:
      '/manual/:id/page/:pageId/question/:questionId/condition/:conditionId',
    name: 'ManualConditionEdit',
    component: ConditionEdit,
    beforeEnter: checkPermission,
  },
  {
    path: '/special-offers',
    name: 'SpecialOffer',
    component: SpecialOffer,
    beforeEnter: checkPermission,
  },
  {
    path: '/special-offers/:id/edit',
    name: 'SpecialOfferEdit',
    component: SpecialOfferEdit,
    beforeEnter: checkPermission,
  },
  {
    path: '/special-offer-receipts',
    name: 'AdminSpecialOfferReceipt',
    component: AdminSpecialOfferReceipt,
    beforeEnter: checkPermission,
  },
  {
    path: '/check-special-offer-receipt',
    name: 'CheckSpecialOfferReceipt',
    component: CheckSpecialOfferReceipt,
  },
  {
    path: '/unchecked-special-offer-receipts',
    name: 'UncheckedSpecialOfferReceipt',
    component: UncheckedSpecialOfferReceipt,
  },
  {
    path: '/unchecked-ng-special-offer-receipts',
    name: 'UncheckedNgSpecialOfferReceipt',
    component: UncheckedNgSpecialOfferReceipt,
    beforeEnter: checkPermission,
  },
  {
    path: '/unchecked-ok-special-offer-receipts',
    name: 'UncheckedOkSpecialOfferReceipt',
    component: UncheckedOkSpecialOfferReceipt,
    beforeEnter: checkPermission,
  },
  {
    path: '/leader-checked-special-offer-receipts',
    name: 'LeaderCheckedSpecialOfferReceipt',
    component: LeaderCheckedSpecialOfferReceipt,
    beforeEnter: checkPermission,
  },
  {
    path: '/leader-ng-special-offer-receipts',
    name: 'LeaderNgSpecialOfferReceipt',
    component: LeaderNgSpecialOfferReceipt,
    beforeEnter: checkPermission,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// Router Guards
router.beforeEach(async (to, from, next) => {
  const jwtToken = localStorage.getItem('jwtToken')
  const ip = localStorage.getItem('ip')
  const hasLogined = to.matched.some(page => {
    return (
      page.path === '/login' ||
      page.path === '/input-email' ||
      page.path === '/password-setting'
    )
  })

  if (hasLogined) {
    next()
    return
  }

  if (!jwtToken || jwtToken.length === 0) {
    next({ path: '/login', query: { backuri: to.fullPath } })
    return
  }

  const user = await store.getters['user/user']

  if (!user) {
    await store.dispatch('user/getMe')
    next({ path: '/' })
    return
  }

  if (user.role === UserRole.ADMIN) {
    if (
      process.env.VUE_APP_API_ORIGIN &&
      process.env.VUE_APP_API_ORIGIN.includes('localhost')
    ) {
      next()
      return
    }
    if (!ip) {
      next({ path: '/login', query: { backuri: to.fullPath } })
      return
    }
    const ips: string[] = [
      '116.91.146.204', // SBF
      '121.103.217.140', // REVONEO new
      '111.239.171.105', // Change me
    ]
    if (ips.indexOf(ip) === -1) {
      next({ path: '/login', query: { backuri: to.fullPath } })
      return
    }
  }

  next()
})

export default router
